import axios, { AxiosError } from 'axios';
import { conexao } from '../../../../offline/conexao';

export const errorInterceptor = (error: AxiosError, reloadOnAuthError = true) => {

  // Sem resposta nenhuma do servidor (rede caída, timeout, DNS) — o PDV
  // passa a trabalhar offline (ver shared/offline). Com resposta (mesmo de
  // erro), o servidor está alcançável.
  if (!axios.isCancel(error)) {
    if (error.response) conexao.marcarOnline();
    else if (error.request) conexao.marcarOffline();
  }

  if (error.response?.status === 401) {
    if (reloadOnAuthError) {
      localStorage.removeItem('APP_ACCESS_TOKEN');
      axios.defaults.headers.authorization = null;
      window.location.reload();
    }
  }

  // Requisições da sincronização offline vão marcadas como `silencioso`
  // (ver shared/offline/sincronizacao.ts): uma rota que ainda não existe no
  // servidor não pode deslogar quem está vendendo.
  const silencioso = (error.config as { silencioso?: boolean } | undefined)?.silencioso === true;
  if (error.response?.status === 404 && !silencioso) {
    if (reloadOnAuthError) {
      localStorage.removeItem('APP_ACCESS_TOKEN');
      axios.defaults.headers.authorization = null;
      window.location.reload();
    }
  }

  if (error.response?.status === 402) {
    //
  }

  if (error.response?.status === 400) {
    return Promise.reject(error.response);
  }


  return Promise.reject(error);
};